import {XCol, XRow, cx, XText} from "@cdx/common";
import {publicProjectStyles} from "./public-project.css";
import cdxLogo from "../../images/codecks-icon-compact.svg";

const OpenFooter = ({publicPath}) => (
  <XCol px={3} pt={6} pb={2} justify="center" align="center">
    <XRow
      sp={1}
      className={cx(publicProjectStyles.footerBox)}
      align="center"
      pl={1}
      pr={2}
      py={0}
      rounded="md"
      elevation={1}
      as="a"
      href={`https://www.codecks.io?utm_medium=open-deck&utm_source=${publicPath}`}
      target="_blank"
      rel="noreferrer"
    >
      <img src={cdxLogo} alt="codecks.io" className={publicProjectStyles.logo} />
      <XCol>
        <XText color="gray200" size={1} preset="bold">
          powered by Codecks
        </XText>
        <XText color="gray300" size={0}>
          Project & Community Management for Game Devs
        </XText>
      </XCol>
    </XRow>
  </XCol>
);

export default OpenFooter;
